import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {Block, CustomSwitch, FormGroup, Select} from "../components";
import {usePropState} from "../utils";
import {useForm, Yup} from "../forms/form";
import {Col, Row} from "react-bootstrap";

export default function AudienceFilterForm({refreshKey, parentFormRef, ...props}) {
  const { t } = useTranslation();
  const [audiences, setAudiences] = useState([]);
  const [audience_scope,] = usePropState(props.audience_scope);
  const [disabled,] = usePropState(props.disabled);

  const {formData, setFormData, getInputProps, validated} = useForm({
    defaultObject: audience_scope,
    initialValues: {key: null, exclusion: false},
    validationSchema: Yup.object().shape({
      key: Yup.string().nullable(),
      exclusion: Yup.boolean(),
    }),
    disabled: disabled,
    parentFormRef: parentFormRef,
  })

  useEffect(() => {
    setFormData(audience_scope);
  }, [audience_scope]);

  useEffect(() => {
    setAudiences(props.audiences.map(audience => ({label: audience.name , value: audience.key })))
  }, [props.audiences])

  return <>
    <Row>
      <Block as={Col} title={t("audience_scope.audience")}>
        <FormGroup label={t("audience_scope.audiences")} {...getInputProps("key")}>
          <Select isClearable={true} placeholder={t("audience_scope.placeholder")} options={audiences} />
        </FormGroup>
        <FormGroup input={CustomSwitch} label={t("audience_scope.exclusion")} {...getInputProps("exclusion")}/>
      </Block>
    </Row>
  </>
}
